import { render, staticRenderFns } from "./pay-parent-plan.vue?vue&type=template&id=0845d82f"
import script from "./pay-parent-plan.vue?vue&type=script&lang=js"
export * from "./pay-parent-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports